import {connect} from 'react-redux';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import lifecycle from 'recompose/lifecycle';
import {getStatus} from 'redux-resource';
import merge from 'lodash/merge';
import withLoadingIndicator from '../../../common/with-loading-indicator';
import {readFile, updateFile, dropStatus} from '../../../../redux/actions/files';
import AdminFileDetails from '../details/index';
import withNavigateToList from '../with-navigate-to-list';

function mapStateToProps(state, {id}) {
	const item = state.files.resources[id];
	const readStatus = getStatus(state, `files.meta[${id}].readStatus`);
	const status = readStatus.succeeded ?
		merge(
			getStatus(state, 'files.requests.update.status'),
			{isLoaded: true}
		) :
		readStatus;

	return {
		status,
		item
	};
}

function mapDispatchToProps(dispatch, props) {
	return {
		cleanUp() {
			dispatch(dropStatus());
		},
		readItem() {
			dispatch(readFile(props.id));
		},
		doSubmit(values) {
			dispatch(updateFile(values))
				.then(props.navigateToList);
		},
		handleCancel() {
			props.navigateToList();
		}
	};
}

const enhance = compose(
	withNavigateToList,
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentDidMount() {
			this.props.readItem();
		},
		componentWillUnmount() {
			this.props.cleanUp();
		}
	}),
	withLoadingIndicator,
	mapProps(props => {
		const {history, cleanUp, ...rest} = props;

		return 	{
			...rest,
			submitLabel: 'Update',
			formTitle: 'File'
		};
	})
);

export default enhance(AdminFileDetails);



// WEBPACK FOOTER //
// ./src/client/components/admin/files/edit/index.js